import React from "react";
import TopBar from "./TopBar";
import Footer from "./Footer";

export default function ContentLayout(props) {
	const { children } = props;
	return (
		<div id="content-wrapper" className="d-flex flex-column">
			<div id="content">
				<TopBar sidebarHandler={props.sidebarHandler} useLang={props.useLang} setUseLang={props.setUseLang} isToggled={props.isToggled} />
				<div id="mainTitleText">
					<span style={{color:"#00398D"}}>HIBALL </span>
					<span style={{color:"#454545", fontWeight:"100"}}>BASEBALL </span>
					<span style={{color:"#454545"}}>SYSTEM</span>
				</div>
				<div className="container-fluid" style={{padding:"15px"}}>
					<div style={{height:"45px", background:"#454545", display:"flex", alignItems:"center", borderRadius:"6px 6px 0px 0px"}}>
						<span className="ball-img" style={{float:"left"}}></span>
						<div style={{color:"#fff", fontSize:"18px", float:"left"}}>{props.menuTitle}</div>
					</div>
					<div className="shadow" style={{background:"#ffffff", minHeight:"700px", padding:"15px 0px 15px 0px", borderRadius:"0px 0px 6px 6px"}}>
						{children}
					</div>
				</div>
			</div>
			<Footer />
		</div>
	);
}
